import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// What a patient's Settings shows under Your clinicians, in one request: the
// clinicians they are connected with and the invitations waiting for an
// answer. data is undefined until the answer arrives or when it failed;
// error and retry are useLoad's.
export function useClinicians() {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Clinicians {
        clinicians { id firstName lastName connectedSince }
        invitations { id sentAt clinician { firstName lastName } }
      }`
    });
  }, [ graphql ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { data, error, retry };
  }, [ data, error, retry ]);
}
